module.exports = __webpack_public_path__ + "images/missing_medium_square-4cd53f4e3a022eeb0ab8bd876a7130fa.png";